<template>
  <NuxtLayout name="auth" :heading="''">
    <LoginComponent v-if="isLogin" @change-view="isLogin = false" @logged-in="navigateAfterAuth" />
    <Register v-else @change-view="isLogin = true" @registered="navigateAfterAuth" />
  </NuxtLayout>
</template>

<script setup lang="ts">
import type { Locale } from '#i18n';

false && /*#__PURE__*/ defineI18nRoute({
  locales: process.env.LANGUAGELIST?.split(',') as Locale[],
});

definePageMeta({
  layout: false,
  middleware: ['guest-guard'],
});
const { setPageMeta } = usePageMeta();

const icon = 'page';
setPageMeta(t('authentication.login.submitLabel'), icon);
useHead({
  meta: [{ name: 'robots', content: 'noindex, nofollow' }],
});

const router = useRouter();
const localePath = useLocalePath();
const isLogin = ref(true);

const navigateAfterAuth = () => {
  const redirectUrl = router.currentRoute.value.query.redirect as string;
  window.location.href = redirectUrl ? localePath(redirectUrl) : localePath(paths.home);
};
</script>
